import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SnackBar } from '@rappi/rests-commons-front';
import { useEffect, useReducer } from 'react';
import { globalContext, initialGlobalState } from './global.context';
import { globalReducer } from './global.reducer';
import { StyledBasicModal } from './styles';
import { GlobalActions } from './types';
export const GlobalProvider = ({ children, initialState }) => {
    var _a;
    const [state, dispatch] = useReducer(globalReducer, Object.assign(Object.assign({}, initialGlobalState), initialState));
    const handleHideNotification = () => {
        dispatch({ type: GlobalActions.hideNotification });
    };
    const handleCloseModalBasic = () => {
        dispatch({ type: GlobalActions.hideModalBasic });
    };
    useEffect(() => {
        var _a;
        void ((_a = state.auth) === null || _a === void 0 ? void 0 : _a.getProfile((err, profile) => {
            if (err) {
                dispatch({
                    type: GlobalActions.showNotification,
                    payload: {
                        message: err.message,
                        title: 'Error',
                        type: 'error',
                    },
                });
            }
            if (profile) {
                dispatch({ type: GlobalActions.setUserProfile, payload: profile });
            }
        }));
    }, [state.auth]);
    return (_jsxs(globalContext.Provider, { value: { state, dispatch }, children: [_jsx(SnackBar, { closeOnClick: true, hidePageOverlay: true, show: Boolean(state.notification.message) || Boolean(state.notification.customContent), customContent: state.notification.customContent, message: state.notification.message, type: state.notification.type, title: state.notification.title, position: "top", onHide: handleHideNotification }), _jsx(StyledBasicModal, { open: state.modalBasic.open, title: state.modalBasic.title, buttons: state.modalBasic.buttons, onClose: handleCloseModalBasic, dense: true, "$maxWidth": state.modalBasic.maxWidth, children: state.modalBasic.body }), !((_a = state.auth) === null || _a === void 0 ? void 0 : _a.userProfile) ? null : children] }));
};
